import { zakupyData } from './topics/zakupy-data';
import { domData } from './topics/dom-data';
import { elektronikaData } from './topics/elektronika-data';
import { kuchniaData } from './topics/kuchnia-data';
import { lazienkaData } from './topics/lazienka-data';
import { ogrodData } from './topics/ogrod-data';
import { ogrzewanieData } from './topics/ogrzewanie-data';
import { pozaDomemData } from './topics/poza-domem-data';
import { transportData } from './topics/transport-data';
import { biuroData } from './topics/biuro-data';

export const topicsData = [
    zakupyData,
    biuroData,
    domData,
    elektronikaData,
    kuchniaData,
    lazienkaData,
    ogrodData,
    ogrzewanieData,
    pozaDomemData,
    transportData,
];

export const subtopics = [
    {
        order: 0,
        id: 'odpadySection',
        title: 'Odpady',
        iconPath: 'icons/icon_button_odpady.svg',
    },
    {
        order: 1,
        id: 'klimatSection',
        title: 'Klimat',
        iconPath: 'icons/icon_button_klimat.svg',
    },
    {
        order: 2,
        id: 'energiaSection',
        title: 'Energia',
        iconPath: 'icons/icon_button_energia.svg',
    },
    {
        order: 3,
        id: 'powietrzeSection',
        title: 'Powietrze',
        iconPath: 'icons/icon_button_powietrze.svg',
    },
    {
        order: 4,
        id: 'wodaSection',
        title: 'Woda',
        iconPath: 'icons/icon_button_woda.svg',
    },
];
